// TODO: sostituire le istanze di class con interface per evitare problemi di riferimento e di mutabilità dei dati
export class Container {
  id: number;
  type: string;
  position: string;
  order: number;
  tooltip: string;
  linkedUrl: string;
  staticPreviewUrl: string;
  dynPreviewParams: string;
  dynPreviewUrl: string;
  icon: string;
  iconProps: string;
  contents: Content[] = [];
  bg: string;
  isLoadFinished: boolean = false;
}

export class Content {
  id: number;
  idContainer: number;
  type: string;
  order: number;
  title: string;
  tooltip: string;
  linkedUrl: string;
  icon: string;
  iconProps: string;
  htmlContent: string = "";

}

export class ContentPermission {
  id: number;
  contentId: number;
  group: String;
}

export class Authorization {
  username: string;
  password: string;
  group: string;
}

export class UserDto {
  username: string;
  password: string;
  fName: string;
  sName: string;
  emailAddress: string;
  passwordFirma: string;
  authEmailAddress: string;
}
export class RoleDto {
  roleCode: string;
  applicationCode: string;
  emailAddress: string;
  authEmailAddress: string;
}

export class PhoneBook {

  fName: string;
  lName: string;
  company: string;
  tel: string;
  mail: string;
  photo: string;

}

export class User {
  id: number;
  emailAddress: string;
  name: string;
  surname: string;
  fullName: string;


}
export class ApplicationRoles {
  stato: string;
  ruoli: string;
}
export class Roles {
  ruoli: string;
}
export class WeatherForecast {
  dateFormatted: string;
  temperatureC: number;
  temperatureF: number;
  summary: string;
  sessionName: string;
  sessionAge: number;
}

export class Token {
  token: string;
}

export class LegalEntityEprocessiRiferimentoResult {
  processiRiferimentoDto: ProcessoRiferimento[];
  legalEntities: string[];
  legalEntitiesSelected: string;
}

export class ProcessoRiferimento {
  id: number;
  nome: string;
  deleted: boolean;
  posizione: number;
  ordine: number;
  isAttivo: boolean;
  sottoprocessi: string;
}

export class DocumentiEqualtecResult {
  identificazioneDocumento: string;
  nomeSottoprocesso: string;
  documentoWSDto: Documento;
}

export class EvidenzeResult {
  identificazioneDocumento: string;
  nomeSottoprocesso: string;
  documentoWSDto: Documento;
}

export class DocumentiEqualtecResultObject {
  identificazioneDocumento: string;
  identificazioneDocumentoNum: number;
  documentiEqualtecResultList: DocumentiEqualtecResult[] = [];
  isTabellaAperta: boolean;
  isTabellaConUnElemento: boolean;
  isTabellaRevisionPending: boolean;
}

export class Documento {
  anno: number;
  idDocumento: number;
  descrizioneStrutturaDocumento: string;
  oggettoDocumento: string;
  descrizioneDocumento: string;
  stato: string;
  dataDocumento: Date;
  dataRicezioneDocumento: string;
  isRiservato: boolean;
  segnaturaProtocollo: string;
  dataProtocolazione: Date;
  canaleTrasmissivo: string;
  mittente: string;
  destinatario: string;
  altriDestinatari: string;
  altriDestinatariEsterni: string;
  protocolloMittente: string;
  dataProtocolloMittente: Date;
  idAllegatoPrimario: number;
  idCommittente: number;
  idAllegatiSecondariList: string;
  metadatiTipologiaList: string;
  metadatiDtoViewList: MetadatoTipologiaDto[] = [];
  metadatiDtoList: MetadatoTipologiaDto[] = [];
  metadatiDtoShortList: MetadatoTipologiaDto[] = [];
  isCollapsed: boolean;
  allegatoPrimarioDto: AttachmentDto;
  allegatiSecondariDtoList: AttachmentDto[];
  active: string;
  bg: string;
  isModified: boolean;
  ultimaModificaWS: Date;
  ranking: number;
  numeroFeedback: number;
  FeedbackAcquisito: boolean;
  feedbackSingPlur: string;
  nomeSottoprocesso: string;
  nomeProcessoRiferimento: string;
  identificazioneDocumento: string;
  codice: string;
  revisione: string;
  tipoDocumento: string;
  apriDettaglio: string;
  ismenuAllegato: boolean;
  ismenuAllegatoSecondario: boolean;
  isNewRevisionPending: boolean;
  isDocPreferito: boolean;
  committente: string;
  preparatore: string;
}

export class MetadatoTipologiaDto {
  key: string;
  value: string;
}

export class AttachmentDto {
  idAllegato: string;
  nomeFile: string;
  data: string | Blob;
  estensione: string;
  isTabOpened: boolean;
  isTabVisualizated: boolean;
  presaVisione: boolean;
}

export class TipologiaDto {
  idTipologia: number;
  nomeTipologia: string;
  descrizioneTipologia: string;
}

export class TipologiaServiceITADto extends TipologiaDto {
  TipoDocumento: string[];
}
export class TipologiadetailDto extends TipologiaDto {
  Model: string[];
}
export class TipologiaUserManualsDto extends TipologiaDto {
  Model: string[];
}
export class TipologiaEqualtecDto extends TipologiaDto {
  Model: string[];
}
export class TipologiaMenu {
  title: string;
  childMenu: TipologiaSubMenu[];
}
export class TipologiaSubMenu {
  idTipologia: number;
  title: string;
  isIncludeModel: boolean;
  isIncludeClassification: boolean;
  isIncludeClinicalApplication: boolean;
  isIncludeCorrelatedProbeList: boolean;
  isIncludedApplication: boolean;
  area: string;
}

export class CustomValue {
  key: string;
  value: string;
}

export class Evidenza {
  Documento: number;
  DocumentoUtenteCreatore: string;
  Oggetto: string;
  DataCreazione: Date;
  Descrizione: string;
  PermettiChiusura: boolean;
  Chiusa: boolean;
  Accettata: boolean;
  Destinatari: string[];
  Scadenza: Date;
  DataChiusura: Date;
  DataAccettazione: Date;
  UtenteAccettazione: string;
  UtenteChiusura: string;
  AllegatoFileName: string;
  allegatoId: number;
  Risposte: EvidenzaRisposta[];
  Stato: number;
}
export class Link {
  URL: string;
}

export class EvidenzaRisposta {

  DataCreazione: Date;
  UtenteCreatore: string;
  Descrizione: string;

}

export class AADUsers {
  id: string;
  city: string;
  companyName: string;
  displayName: string;
  givenName: string;
  mail: string;
  surname: string;
  userPrincipalName: string;
  businessPhones: string[];
  mobilePhone: string;
}

export class MeetingRoom {
  name: string;
  address: string;
  status: Availability;
}

export enum Availability {
  FREE = "0",
  BUSY = "2"
}
export class Time {
  text: string;
  value: number;
}

export class SharePointresponse {
  result: any[];
  statusCode: string;
}

